<template>
    <Header
        elements="9"
        current="7"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <div class="checkDetail">
                            <h1>
                                Does your office action mention "Disclaimer" in your trademark application?
                                <Popper>
                                    <span class="GetHelpItem">
                                        <span class="popover-icon">
                                            <i class="fa fa-question-circle" aria-hidden="true"></i>
                                        </span>
                                        Get Help
                                    </span>
                                    <template #content>
                                        <div class="popper-content">
                                            <b>What is a Disclaimer?</b>
                                            <p>A trademark disclaimer is a statement made by the owner of a trademark to explicitly disclaim exclusive rights to certain elements of the trademark that are considered descriptive, generic, or otherwise not distinctive. The purpose of a disclaimer is to clarify the scope of protection sought for the trademark and to prevent the owner from asserting rights over elements that are common or necessary for others to use in describing their goods or services.</p>
                                        </div>
                                    </template>
                                </Popper>
                            </h1>
                            <div class="MuiBox-root css-1rrbnz">
                                <RadioCheckbox
                                    :value="params.is_disclaimer"
                                    @change_c="changeParams($event)"
                                    type="radio"
                                    value_v="No"
                                    text="No"
                                    name="is_likelihood_of_confusion"
                                ></RadioCheckbox>
                                <RadioCheckbox
                                    :value="params.is_disclaimer"
                                    @change_c="changeParams($event)"
                                    type="radio"
                                    value_v="Yes"
                                    text="Yes"
                                    name="is_likelihood_of_confusion"
                                ></RadioCheckbox>
                                <RadioCheckbox
                                    :value="params.is_disclaimer"
                                    @change_c="changeParams($event)"
                                    type="radio"
                                    value_v="Not_Sure"
                                    text="Not Sure"
                                    name="is_likelihood_of_confusion"
                                ></RadioCheckbox>
                            </div>

                            <div v-if="params.is_disclaimer == 'No'" id="ans_4_0" class="ans_4" style="">
                                <div class="inputSec">
                                    <p>Fantastic, nothing to worry about here. Please click “Next” below so we can proceed to the next step.</p>
                                </div>
                            </div>
                            <div v-else-if="params.is_disclaimer == 'Yes'" id="ans_4_1" class="ans_4">
                                <div class="inputSec">
                                    <p class="d-block mb-12">
                                        That's no problem. The USPTO simply believes that your trademark contains a word which is generic to the products/services listed and because no one Applicant can be the exclusive “owner” of this word, vis-à-vis the products/services listed, you must “disclaim” your right to this particular word/s.  To handle “Procedural Office Actions”, which require a simple amendment to the Application, we charge a legal service fee of $250.
                                    </p>
                                </div>
                            </div>
                            <div v-else-if="params.is_disclaimer == 'Not_Sure'" id="ans_4_2" class="ans_4">
                                <div class="inputSec">
                                    <p>Ok, no problem at all. We'll review your Office Action for you and contact you to discuss any outstanding matters after you finish onboarding with us.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="true"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import http from "@/api/http";
import BottomButton from '@/ui/Bottom-Button.vue'
import TextareaElement from '@/ui/Input-Textarea.vue'
import RadioCheckbox from '@/ui/Radio-Checkbox.vue'
import Freezeframe from '@/components/Freezeframe.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        BottomButton,
        RadioCheckbox,
        TextareaElement,
        Freezeframe
    },
    data() {
        return {
            params: {
                is_disclaimer: 'No'
            }
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init() {
            let { data } = await http.get('trademark-office-action/step-5/' + this.$route.params.key);

            if (data.res) {
                this.params = data.data.data

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        async changeParams(value) {
            this.params.is_disclaimer = value

            let { data } = await http.put('trademark-office-action/step-5/' + this.$route.params.key, this.params);

            if (data.res) {
                this.init()
            }
        },
        async next() {
            this.$router.push({ path: '/trademark-office-action/step-6/' + this.$route.params.key })
        },
        back() {
            this.$router.push({ path: '/trademark-office-action/step-4/' + this.$route.params.key })
        }
    }
}
</script>
